import React from 'react';
import { Link } from 'react-router-dom';

// Import images
import breadcrumbBg from '../../assets/img/bg/breadcrumb-bg.png';
import cloudIcon from '../../assets/img/icons/cloud.png';
import ballonIcon from '../../assets/img/icons/ballon-sclation.png';
import destinationThumb1 from '../../assets/img/destination/destinations-thumb-2-1.png';
import destinationThumb2 from '../../assets/img/destination/destinations-thumb-2-2.png';
import destinationThumb3 from '../../assets/img/destination/destinations-thumb-2-3.png';
import destinationThumb4 from '../../assets/img/destination/destinations-thumb-2-4.png';
import destinationThumb5 from '../../assets/img/destination/destinations-thumb-2-5.png';
import destinationThumb6 from '../../assets/img/destination/destinations-thumb-2-6.png';
import destinationThumb7 from '../../assets/img/destination/destinations-thumb-2-7.png';
import destinationThumb8 from '../../assets/img/destination/destinations-thumb-2-8.png';
import destinationThumb9 from '../../assets/img/destination/destinations-thumb-2-9.png';
import destinationThumb10 from '../../assets/img/destination/destinations-thumb-2-10.png';

const DestinationDetails = () => {
    const destinations = [
        {
            id: 1,
            image: destinationThumb1,
            title: "manila city",
            places: "30 Place"
        },
        {
            id: 2,
            image: destinationThumb2,
            title: "turkey",
            places: "10 Place"
        },
        {
            id: 3,
            image: destinationThumb3,
            title: "Los Angeles",
            places: "14 Place"
        },
        {
            id: 4,
            image: destinationThumb4,
            title: "vietnam",
            places: "10 Place"
        },
        {
            id: 5,
            image: destinationThumb5,
            title: "china tours",
            places: "30 Place"
        },
        {
            id: 6,
            image: destinationThumb6,
            title: "germany",
            places: "10 Place"
        },
        {
            id: 7,
            image: destinationThumb7,
            title: "Turkey",
            places: "3 Place"
        },
        {
            id: 8,
            image: destinationThumb8,
            title: "cairo tour",
            places: "10 Place"
        },
        {
            id: 9,
            image: destinationThumb9,
            title: "span tour",
            places: "10 Place"
        },
        {
            id: 10,
            image: destinationThumb10,
            title: "netherlands",
            places: "10 Place"
        }
    ];

    return (
        <div className="about-page">
            {/* Breadcrumb Section */}
            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: `url(${breadcrumbBg})` }}
            >
                <img
                    src={cloudIcon}
                    alt="cloud icon"
                    className="vs-breadcrumb-icon-1 animate-parachute"
                />
                <img
                    src={ballonIcon}
                    alt="balloon icon"
                    className="vs-breadcrumb-icon-2 animate-parachute"
                />
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">Destinations</h1>
                            </div>
                            <div className="breadcrumb-menu">
                                <ul className="custom-ul">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>Destination Details</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Destinations Grid */}
            <section style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row">
                        {destinations.map((destination) => (
                            <div key={destination.id} className="col-md-6 col-lg-4 mb-4">
                                <div
                                    className="destination-card"
                                    style={{
                                        background: 'white',
                                        borderRadius: '15px',
                                        overflow: 'hidden',
                                        boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                        transition: 'transform 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }}
                                >
                                    <img
                                        src={destination.image}
                                        alt={destination.title}
                                        style={{
                                            width: '100%',
                                            height: '200px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <div style={{ padding: '20px' }}>
                                        <h5 style={{ margin: '0 0 10px 0', textTransform: 'capitalize' }}>
                                            {destination.title}
                                        </h5>
                                        <p style={{ margin: 0, color: '#666' }}>
                                            {destination.places}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <style jsx>{`
                .destination-details-page {
                    min-height: 100vh;
                }
                
                .breadcrumb-section {
                    position: relative;
                }
                
                .breadcrumb-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.5);
                }
                
                .breadcrumb-section .container {
                    position: relative;
                    z-index: 2;
                }
            `}</style>
        </div>
    );
};

export default DestinationDetails;